<div class="ua-settings-container">

  <!-- Gate state: Azure tenant not configured -->
  <div *ngIf="!isTenantConfigured" class="accs-gate-state">
    <mat-icon class="accs-gate-icon">lock_outline</mat-icon>
    <p class="accs-gate-title">Azure tenant not configured</p>
    <p class="accs-gate-sub">
      Set up the Azure service principal before adding account subscriptions.
    </p>
    <button mat-flat-button color="primary" (click)="goToTenant.emit()">
      <mat-icon>domain</mat-icon> Go to Tenant Settings
    </button>
  </div>

  <!-- Section header — only visible when tenant is configured and subscriptions exist -->
  <ng-container *ngIf="isTenantConfigured && rows.length > 0">
    <div class="section-header-row">
      <div>
        <h3 class="ua-settings-title">Account Subscriptions</h3>
        <p class="ua-settings-subtitle">
          Manage Azure subscriptions used for User Account template resources.
          One subscription per participant is recommended (plus one reserved for template testing).
        </p>
      </div>
      <div class="section-header-actions">
        <button mat-flat-button color="primary" (click)="openAddDialog()">
          <mat-icon>add</mat-icon> Add Subscriptions
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Low-subscriptions warning -->
  <div *ngIf="isTenantConfigured && rows.length > 0 && isLowOnSubscriptions" class="ua-warning-banner">
    <mat-icon>warning_amber</mat-icon>
    <span>{{ lowSubsWarning }}</span>
  </div>

  <!-- Empty state: tenant configured but no subscriptions added yet -->
  <div *ngIf="isTenantConfigured && rows.length === 0" class="accs-gate-state">
    <mat-icon class="accs-gate-icon accs-gate-icon--empty">manage_accounts</mat-icon>
    <p class="accs-gate-title">No account subscriptions added yet.</p>
    <p class="accs-gate-sub">Add an Azure subscription to assign User Account template resources.</p>
    <button mat-flat-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon> Add Subscriptions
    </button>
  </div>

  <!-- Subscription table -->
  <div *ngIf="isTenantConfigured && rows.length > 0" class="table-container">
    <table mat-table [dataSource]="dataSource" class="acc-sub-table">

      <!-- Display Name -->
      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef>Subscription</th>
        <td mat-cell *matCellDef="let row">
          <div class="sub-name-cell">
            <strong>{{ row.displayName || 'Unnamed' }}</strong>
            <span *ngIf="row.isClaimed" class="sub-claimed-badge">
              <mat-icon class="sub-claimed-icon">lock</mat-icon> Template in use
            </span>
            <span *ngIf="!row.isClaimed && row.hasUserAad" class="sub-claimed-badge">
              <mat-icon class="sub-claimed-icon">lock</mat-icon> User AAD account active
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Subscription ID -->
      <ng-container matColumnDef="subscriptionId">
        <th mat-header-cell *matHeaderCellDef>Subscription ID</th>
        <td mat-cell *matCellDef="let row">
          <span class="mono-text">{{ row.subscriptionId }}</span>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="warn" [disabled]="row.isRemoving || row.isClaimed || row.hasUserAad"
            [matTooltip]="removeTooltip(row)" (click)="removeRow(row)">
            <mat-spinner *ngIf="row.isRemoving" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!row.isRemoving">delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      appPersistPageSize="class:accountSubscriptions:list" showFirstLastButtons
      aria-label="Select page of account subscriptions">
    </mat-paginator>
  </div>

</div>